module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "col-md-12 flecha-container"
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("NOSOTROS")]), _vm._v(" "), _c('img', {
    staticClass: "flecha",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1500",
      "src": require("imgs/icons/Flecha_Negra.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "nosotros"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "col-sm-4 text-right pull-left",
    attrs: {
      "id": "left"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "2500"
    }
  }, [_c('div', {
    staticClass: "col-sm-3 icon minor-res-disp"
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Nostros_Foco.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 "
  }, [_c('p', [_vm._v("A&A Logistics Group fue fundada originalmente con el nombre de A&A FORWARDERS en Octubre del 2007.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 icon major-res-disp"
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Nostros_Foco.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "2500"
    }
  }, [_c('div', {
    staticClass: "col-sm-3 icon minor-res-disp"
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Nosotros_Lapiz.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('p', [_vm._v("Fue en el 2009 cuando cambiamos nuestro nombre A&A Logistics Group.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 icon major-res-disp"
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Nosotros_Lapiz.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-anchor-placement": "bottom-bottom",
      "data-aos-duration": "1000",
      "id": "image-col"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/nosotros_truck.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-left pull-right",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-duration": "2500",
      "id": "right"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 icon"
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Nosotros_Certificado.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('p', [_vm._v("Nuestra certificación C-TPAT nos ha permitido ganar la confianza de nuestros clientes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-duration": "2500"
    }
  }, [_c('div', {
    staticClass: "col-sm-3 icon"
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Nosotros_Mano.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('p', [_vm._v("A través de los años hemos logrado ser una empresa con un alto nivel de profesionalismo.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c169a74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nosotros.vue
// module id = 79
// module chunks = 0